export default __webpack_public_path__ + "static/media/cz.4920f112.svg";